import React from 'react';
import './MapSection.css';

const MapSection = () => {
  const handleMapClick = () => {
    // Open Google Maps in a new tab with the exact location
    window.open('https://www.google.com/maps/place/25%C2%B008\'03.0%22N+55%C2%B015\'01.8%22E/@25.134173,55.250494,17z/data=!3m1!4b1!4m4!3m3!8m2!3d25.134173!4d55.250494?entry=ttu&g_ep=EgoyMDI1MDgwNi4wIKXMDSoASAFQAw%3D%3D', '_blank');
  };

  return (
    <section className="map-section">
      <div className="container">
        <div className="section-header">
          <h2>Find Our Location</h2>
          <p>Visit our metal coating and fabrication facility in Al Quoz Industrial Area 2, Dubai for a personal consultation and see our state-of-the-art equipment in action.</p>
        </div>
        
        <div className="map-container">
          <div className="map-embed" onClick={handleMapClick}>
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3608.123456789!2d55.250494!3d25.134173!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjXCsDA4JzAzLjAiTiA1NcKwMTUnMDEuOCJF!5e0!3m2!1sen!2sae!4v1641234567890"
              width="100%" 
              height="450" 
              style={{ border: 0, pointerEvents: 'none' }} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="Glitter Metal Coating and Fabrication - Warehouse 18, Al Quoz Industrial Area 2, Dubai"
            ></iframe>
            <div className="map-overlay" onClick={handleMapClick}></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapSection; 